import * as React from 'react';
import {FC, useEffect, useRef, useState} from 'react';

import styles from './footer.module.css';
import {classNames} from 'primereact/utils';
import {useRecords} from '../../models/records/records-provider';
import {formatAs800PhoneNumber} from '../../utils/phone';
import {NAVIGATION_ITEMS} from '../../constants/navigation';
import {Link, useNavigate} from 'react-router-dom';
import {usePages} from '../../models/pages/pages-provider';

const Footer: FC = () => {
  const { mappedData } = useRecords();
  const navigate = useNavigate();
  const {
    data = [],
  } = usePages();
  // const [footerHeight, setFooterHeight] = useState(0);
  // const footerRef = useRef<HTMLDivElement>(null);
  //
  // useEffect(() => {
  //   const updateFooterHeight = () => {
  //     if (footerRef.current) {
  //       setFooterHeight(footerRef.current?.offsetHeight);
  //     }
  //   };
  //
  //   updateFooterHeight();
  //   window.addEventListener('resize', updateFooterHeight);
  //
  //   return () => {
  //     window.removeEventListener('resize', updateFooterHeight);
  //   };
  // }, []);


  const phoneNumber = mappedData['phone-8-800'];
  const phoneToDisplay = formatAs800PhoneNumber(phoneNumber);
  const phoneNumber2 = mappedData['phone-8-800_2'];
  const phoneToDisplay2 = formatAs800PhoneNumber(phoneNumber2);

  const navigationItems = NAVIGATION_ITEMS({ navigate, pages: data });

  const logoElement = (
    <div className="flex flex-column">
      <Link to={'/'} className="flex align-items-center mb-2 no-underline">
        <img
          src={'/images/logo-projection.svg'}
          width={54}
          height={54}
          alt={'Электрические сети Сибири'}
          className="mr-3"
        />
        <span className={styles.logoText}>
          Электрические<br/>
          Сети Сибири
        </span>
      </Link>
      <div className={classNames(styles.minorText, 'text-sm mt-auto')}>
        © Все права защищены, {new Date().getFullYear()}
      </div>
    </div>
  );

  const renderNavigationColumn = (items?: any[], title?: string) => {
    return (
      <div className="flex flex-column h-full">
        <h4 className="text-white mb-3 text-lg">{title}</h4>
        <ul className="list-none p-0 m-0 flex flex-column gap-2">
          {items?.[0]?.[0]?.items.map((link: any) => (
            <li key={link.id}>
              <span
                className={classNames(styles.minorText, 'hover:text-white cursor-pointer no-underline text-sm')}
                onClick={() =>  link.command()}
              >
                {link.label || link.id}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  const contactColumn = (
    <div className="flex flex-column h-full">
      <h4 className="text-white mb-3 text-lg">Контакты</h4>
      <div className="flex flex-column gap-3">
        <div>
          <div className={classNames(styles.minorText, 'text-sm text-white-50 mb-1')}>Горячая линия</div>
          <a
            href={`tel:${phoneNumber}`}
            className="text-white font-semibold no-underline hover:text-primary-300"
          >
            {phoneToDisplay}
          </a>
          <br/>
          <a
            href={`tel:${phoneNumber2}`}
            className="text-white font-semibold no-underline hover:text-primary-300"
          >
            {phoneToDisplay2}
          </a>
        </div>
        <div>
          <div className={classNames(styles.minorText, 'text-sm text-white-50 mb-1')}>Электронная почта</div>
          <div className="text-white font-semibold">info@eseti.site</div>
        </div>
        <div>
          <div className={classNames(styles.minorText, 'text-sm text-white-50 mb-1')}>Диспетчерская служба</div>
          <div className="text-white font-semibold">005</div>
        </div>
        <div>
          <div className={classNames(styles.minorText, 'text-sm text-white-50 mb-1')}>График работы</div>
          <div className="text-white font-semibold">Пн-Пт: 09:00 - 18:00</div>
          <div className="text-white font-semibold">Обед: 12:00 - 13:00</div>
          <div className="text-white font-semibold">Вс-Сб: выходной</div>
        </div>
        <div>
          <div className={classNames(styles.minorText, 'text-sm text-white-50 mb-1')}>Прием юр. и физ. лиц</div>
          <div className="text-white font-semibold">Пн-Ср: 09:00 - 15:00</div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      // ref={footerRef}
      className={classNames(styles.footerWrapper)}
    >
      <div className="grid w-full justify-content-start">
        <div className="col-12 md:col-6 lg:col-3 flex">
          {logoElement}
        </div>
        <div className="col-12 md:col-6 lg:col-3 flex mt-3 md:mt-0">
          {contactColumn}
        </div>
        {navigationItems?.slice(0, 2).map((navGroup, index) => (
          <div key={`nav-${index}`} className="col-12 md:col-6 lg:col-3 flex">
            {renderNavigationColumn(navGroup.items, navGroup.label)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Footer;
